import { render, staticRenderFns } from "./command_panel.vue?vue&type=template&id=8229bcc4&"
import script from "./command_panel.vue?vue&type=script&lang=js&"
export * from "./command_panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports